import { tsAnimalHistory } from '../../Typescript/DB_Interface'
import { formatValueDateTime } from '../../Functions/FormatValues'
import { DataGridPro } from '@mui/x-data-grid-pro'

function AnimalHistory({
  history,
  loading,
}: {
  history: tsAnimalHistory[]
  loading: boolean
}) {
  return (
    <DataGridPro
      sx={{ width: 1 }}
      rows={history}
      columns={[
        {
          field: 'StatusDate',
          headerName: 'Date',
          flex: 1.5,
          valueFormatter: (value: any) => formatValueDateTime(value),
        },
        {
          field: 'EmployeeID',
          headerName: 'Employee',
          flex: 1,
        },
        {
          field: 'AnimalHistoryComments',
          headerName: 'Comments',
          flex: 5,
        },
      ]}
      getRowId={(row) => row.StatusDate + '' + row.AnimalHistoryComments}
      disableColumnMenu
      autoHeight
      hideFooter
      density={'compact'}
      loading={loading}
      initialState={{
        sorting: {
          sortModel: [{ field: 'StatusDate', sort: 'asc' }],
        },
      }}
    />
  )
}

export default AnimalHistory
